<button (click)="dismiss()" type="button" class="mui-modal__close" aria-label="Close">
  <i mui-icon font="fa" name="times"></i>
</button>
<div class="mui-modal__header">
  <h3 class="mui-modal__title">
    {{ 'dashboardPage.widgetConfigDialog.title' | translate: { widgetName: widgetName | translate } }}
  </h3>
</div>
<form [formGroup]="form" (ngSubmit)="save(form.value)">
  <div class="mui-modal__body" *ngIf="content">
    <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: form, form: form }">
      <!-- The inner content will be displayed here -->
    </ng-container>
  </div>
  <div class="mui-modal__footer">
    <button mui-btn appearance="secondary" class="dismiss-button" type="button" (click)="dismiss()" aria-label="Close">
      {{ 'global.btn.cancel' | translate }}
    </button>
    <button mui-btn appearance="primary" type="submit" class="confirm-button" [disabled]="form.invalid" aria-label="Confirm">
      {{ 'global.btn.save' | translate }}
    </button>
  </div>
</form>
